module.exports = __webpack_public_path__ + "img/SUNEL-LOGO.8ac077c7.jpg";